export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8536.83a901e4.jpg";